module.exports = __webpack_public_path__ + "img/045.2f7d8bc8.jpg";